export enum InvoiceKsefStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Success = 'SUCCESS',
  Error = 'ERROR',
}
